<template>
    <div class="home">
        <div v-if="showSplash && splashAd" class="splash-mask" @click.self="closeSplash">
            <div class="splash-box">
                <a :href="splashAd.url || 'javascript:void(0)'" target="_blank" rel="noopener noreferrer">
                    <img :src="splashAd.pic" alt="" />
                </a>
                <div class="splash-close" @click="closeSplash">关闭</div>
            </div>
        </div>
        <!-- 轮播 -->
        <van-swipe class="my-swipe" :autoplay="3000" lazy-render touchable>
            <van-swipe-item v-for="item in swiperArr" :key="item.id">
                <a href="javascript:void(0)" @click="goSwiperLink(item)">
                    <img :src="item.pic" alt="" class="slide-img">
                </a>
            </van-swipe-item>
        </van-swipe>
        <!-- 公告 -->
       <van-notice-bar
            scrollable
            mode="closeable"
            left-icon="volume-o"
            :text="webInfo.notice"
        />
        <!-- 主体区域 -->
        <div class="content-box">
            <!-- 应用导航 -->
            <main-nav></main-nav>
            <!-- 热门推荐 -->
            <home-slide :dataList="hotList"></home-slide>
            <!-- 站长推荐 -->
            <div class="tools-content">
                <Tools :dataList="allList" :dtitle="'站长推荐'"></Tools>
            </div>
        </div>

        <div
            v-for="(item, index) in homeFloatAds"
            :key="`float-${item.id || index}`"
            class="home-float-ad"
            :class="index % 2 === 0 ? 'is-right' : 'is-left'"
            :style="{ top: `${36 + Math.floor(index / 2) * 22}%` }"
        >
            <a :href="item.url || 'javascript:void(0)'" target="_blank" rel="noopener noreferrer">
                <img :src="item.pic" alt="" />
            </a>
            <div class="close" @click="removeFloatAd(index)">x</div>
        </div>

        <div v-if="homeBottomAds.length" class="home-bottom-ad-wrap">
            <div v-for="(item, index) in homeBottomAds" :key="`bottom-${item.id || index}`" class="home-bottom-ad">
                <a :href="item.url || 'javascript:void(0)'" target="_blank" rel="noopener noreferrer">
                    <img :src="item.pic" alt="" />
                </a>
                <div class="close" @click="removeBottomAd(index)">x</div>
            </div>
        </div>
    </div>
</template>

<script>
import HomeSlide from "@/components/Slide.vue"
import Tools from "@/components/tools.vue"
import MainNav from "@/components/MainNav.vue"

export default {
    components: {
        MainNav,
        HomeSlide,
        Tools
    },
    data() {
        return {
            webInfo: {
                title: "网站标题",
                notice: "这里是公告,点击右侧 x 按钮可关闭哦"
            },
            swiperArr: [],
            hotList: [],
            allList: [
                { id: 1, pic: "", num: 9999, title: "名称", details: "应用介绍"}
            ],
            homeFloatAds: [],
            homeBottomAds: [],
            splashAd: null,
            showSplash: false
        }
    },
    methods: {
        // 网站信息
        async getSet() {
            const { data: res } = await this.$http.get('/set')
            this.webInfo = res.data[0]
        },
        // 轮播
        async getSwiperList() {
            const { data: res } = await this.$http.get('/swiper_list')
            this.swiperArr = res.data
        },
        // 热门推荐
        async getHotList() {
            const { data: res } = await this.$http.get('/list_class', {
                params: { class: '热门应用' }
            })
            const list = Array.isArray(res.data) ? res.data : []
            this.hotList = list
                .slice()
                .sort((first, second) => Number(second.num || 0) - Number(first.num || 0))
                .slice(0, 10)
        },
        // 站长推荐
        async getAllList() {
            const { data: res } = await this.$http.get('/list_class', {
                params: { class: '推荐应用' }
            })
            const list = Array.isArray(res.data) ? res.data : []
            this.allList = list
                .slice()
                .sort((first, second) => Number(second.num || 0) - Number(first.num || 0))
                .slice(0, 10)
        },
        async goSwiperLink(item) {
            if (!item || !item.url) return
            try {
                await this.$http.post('/track_click', {
                    target_type: 'swiper',
                    target_id: item.id
                })
            } catch (error) {
                // 统计失败不阻断跳转
            }
            window.open(item.url, '_blank')
        },
        async getAdSlot(adType) {
            const { data: res } = await this.$http.get('/ad_slot_list', {
                params: { ad_type: adType }
            })
            return res.data || []
        },
        normalizeAdsByType(list, adType) {
            if (!Array.isArray(list)) return []
            return list.filter((item) => {
                const type = String(item?.ad_type || '').trim()
                const pic = String(item?.pic || '').trim()
                return type === adType && !!pic
            })
        },
        async getHomeAds() {
            try {
                const [floatList, bottomList, splashList] = await Promise.all([
                    this.getAdSlot('home_float'),
                    this.getAdSlot('home_bottom'),
                    this.getAdSlot('splash')
                ])
                this.homeFloatAds = this.normalizeAdsByType(floatList, 'home_float')
                this.homeBottomAds = this.normalizeAdsByType(bottomList, 'home_bottom')
                this.splashAd = this.normalizeAdsByType(splashList, 'splash')[0] || null

                const splashShown = sessionStorage.getItem('home_splash_shown')
                if (this.splashAd && splashShown !== '1') {
                    this.showSplash = true
                    sessionStorage.setItem('home_splash_shown', '1')
                }
            } catch (error) {
                this.homeFloatAds = []
                this.homeBottomAds = []
                this.splashAd = null
            }
        },
        removeFloatAd(index) {
            this.homeFloatAds.splice(index, 1)
        },
        removeBottomAd(index) {
            this.homeBottomAds.splice(index, 1)
        },
        closeSplash() {
            this.showSplash = false
        }
    },
    created() {
        this.getSet()
        this.getSwiperList()
        this.getHotList()
        this.getAllList()
        this.getHomeAds()
    }
}
</script>

<style lang="less" scoped>
.my-swipe {
    width: 100%;
    height: 15rem;
}
.slide-img {
    width: 100%;
    height: 15rem;
    object-fit: contain;
    background: #f7f8fa;
}
// 公告
.van-notice-bar {
    border-radius: 0.5rem;
    color: #ff5a5e;
    font-size: 1.5rem;
    line-height: 1.5rem;
    height: 3.5rem;
    margin-top: 1rem;
}
.content-box {
    padding: 1rem 1rem 0 1rem;
}
.tools-content {
    margin-top: 1rem;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 5px;
    box-shadow: 0 0 10px #dedede;
}
.home-float-ad {
    position: fixed;
    width: 4.8rem;
    z-index: 998;
    &.is-right {
        right: .4rem;
    }
    &.is-left {
        left: .4rem;
    }
    img {
        width: 100%;
        border-radius: .5rem;
        box-shadow: 0 0 10px rgba(0, 0, 0, .2);
    }
    .close {
        text-align: center;
        font-size: .9rem;
        color: #fff;
        background: rgba(0, 0, 0, .6);
        border-radius: .3rem;
        margin-top: .2rem;
    }
}
.home-bottom-ad-wrap {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 4.8rem;
    width: calc(100% - 1rem);
    max-width: 740px;
    z-index: 997;
    display: flex;
    flex-direction: column;
    gap: .35rem;
}

.home-bottom-ad {
    position: relative;
    img {
        width: 100%;
        height: 4rem;
        object-fit: contain;
        background: #f7f8fa;
        border-radius: .5rem;
        box-shadow: 0 0 10px rgba(0, 0, 0, .18);
    }
    .close {
        position: absolute;
        right: .2rem;
        top: .2rem;
        width: 1.2rem;
        line-height: 1.2rem;
        text-align: center;
        color: #fff;
        font-size: .8rem;
        border-radius: 50%;
        background: rgba(0, 0, 0, .55);
    }
}

.splash-mask {
    position: fixed;
    inset: 0;
    z-index: 1200;
    background: rgba(0, 0, 0, .55);
    display: flex;
    align-items: center;
    justify-content: center;
    .splash-box {
        width: calc(100% - 2rem);
        max-width: 420px;
        img {
            width: 100%;
            border-radius: .8rem;
        }
        .splash-close {
            margin-top: .7rem;
            line-height: 2rem;
            text-align: center;
            color: #fff;
            border: 1px solid #fff;
            border-radius: 2rem;
            font-size: .95rem;
        }
    }
}
</style>